<template>
  <div class="home">
    <div
      class="home-products-section flex gap-4 flex-col-reverse md:flex-row"
    >
      <Filters class="filters-section md:1/4 lg:w-1/5" />
      <div class="sub-route-container md:w-3/4 lg:w-4/5">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from "@/components/Products/ProductCard.vue";
import Filters from "@/components/Filters";
export default {
  name: "HomeView",
  components: { ProductCard, Filters },
};
</script>

<style>
.home {
  width: 98%;
  margin: 0 auto;
}

.home-products-section {
  width: 100%;
}

.filters-section {
  height: min-content;
}
</style>
